import {
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Theme
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import useRouter from 'use-react-router';
import {TableEditBar} from '../../../components/TableEditBar';
import {PaginatiorInfo} from '../../../graphql/common.datatypes';
import {formatDate,formatMoney} from '../../../utils/formatters';
import {BillingParty} from '../../../graphql/billing_party.datatypes';
import moment from 'moment';
import {yellow} from '@material-ui/core/colors';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    content: {
        padding: 0
    },
    inner: {
      [theme.breakpoints.up('md')]: {
        minWidth: 700,
      },
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
    pastdue: {
        backgroundColor: yellow[100],
        '&:hover': {
            backgroundColor: yellow[200]
        }
    },
    pastdueChip: {
        backgroundColor: yellow[800]
    },
}));

const Results = (props: {
  className?: string,
  billingParties: BillingParty[],
  paginatorInfo?: PaginatiorInfo,
  setPage?: (page: number) => void,
  rowsPerPage?: number,
  setRowsPerPage?: (rowsPerPage: number) => void,
  selectedBillingParty?: BillingParty,
  setSelectedBillingParty?: (party: BillingParty) => void,
    isAdmin?: boolean,
    canEdit?: boolean,
    paymentFilters?: any[],
}) => {
   let {billingParties, paymentFilters, className, rowsPerPage, setPage, setRowsPerPage, paginatorInfo, selectedBillingParty, setSelectedBillingParty, isAdmin, canEdit, ...rest} = props;
    const classes = useStyles();
    const {history} = useRouter();
    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        if (setPage) setPage(page + 1);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if (setRowsPerPage) setRowsPerPage(Number(event.target.value));
    };

    if (paymentFilters) {
        if (paymentFilters[0].value1 && !paymentFilters[0].value2) {
            billingParties = billingParties.filter(value => value.hasPendingECheckPayments)
        } else if (!paymentFilters[0].value1 && paymentFilters[0].value2) {
            billingParties = billingParties.filter(value => !value.hasPendingECheckPayments)
        } else {
            billingParties = props.billingParties
        }
    }

    return (
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
          <Card>
              <CardHeader
                title={'Billing Parties'}
              />
              <Divider/>
              <CardContent className={classes.content}>
                  <PerfectScrollbar>
                      <div className={classes.inner}>
                          <Table>
                              <TableHead>
                                  <TableRow>
                                      {isAdmin && (<TableCell style={{width: 100}}>Id</TableCell>)}
                                      {!isAdmin && (<TableCell >Event</TableCell>)}
                                      <TableCell>Primary Member</TableCell>
                                      <TableCell style={{width: 100}}>Total</TableCell>
                                      <TableCell style={{width: 100}}>Outstanding</TableCell>
                                      <TableCell style={{width: 100}}>Past due</TableCell>
                                      <TableCell style={{width: 100}}>Pending E-check</TableCell>
                                      <TableCell style={{width: 100}}>Check In</TableCell>
                                      <TableCell style={{width: 100}}>Check Out</TableCell>
                                      <TableCell style={{width: 100}}># Travellers</TableCell>
                                  </TableRow>
                              </TableHead>
                              <TableBody>
                                  {billingParties.map(party => {
                                      const pimary = party.payingMembers && party.payingMembers.find(member => member.primary_paying_member);
                                      const showPrices = isAdmin || (moment(party.booking!.end_date).add(15, 'days').diff(moment(), 'days') > 0);

                                      return (
                                          <TableRow
                                              hover
                                              key={party.id}
                                              selected={selectedBillingParty === party}
                                              className={clsx({
                                                  [classes.pastdue]: party.overduePayments,
                                              })}
                                              onClick={() => setSelectedBillingParty ?
                                                  setSelectedBillingParty(party) :
                                                  isAdmin ?
                                                      history.push('/billing_party/' + party.id) :
                                                      history.push('/mygroups/billing_party/' + btoa(JSON.stringify({
                                                          id: party.id,
                                                          groupRef: party.booking!.group!.booking_form_url
                                                      })))
                                              }
                                          >
                                              {isAdmin && (<TableCell>{party.id}</TableCell>)}
                                              {!isAdmin && (<TableCell>{party.booking!.group!.tour!.display_name}</TableCell>)}
                                              <TableCell>{pimary && (pimary.first_name + ' ' + pimary.last_name)}</TableCell>
                                              <TableCell>{showPrices ? (formatMoney(party.cost!,true)) : 'n/a'}</TableCell>
                                              <TableCell>{showPrices ? (formatMoney(party.outstandingBalance!,true)) : 'n/a'}</TableCell>
                                              <TableCell>{showPrices ? (formatMoney(party.overduePayments!,true)) : 'n/a'}</TableCell>
                                              <TableCell>{party.hasPendingECheckPayments ? 'Yes' : 'No'}</TableCell>
                                              <TableCell>{party.booking && formatDate(party.booking.start_date)}</TableCell>
                                              <TableCell>{party.booking && formatDate(party.booking.end_date)}</TableCell>
                                              <TableCell>{party.members && party.members.length}</TableCell>
                                          </TableRow>
                                      )
                                  })}
                              </TableBody>
                          </Table>
                      </div>
                  </PerfectScrollbar>
              </CardContent>
            {paginatorInfo && rowsPerPage && (
              <CardActions className={classes.actions}>
                <TablePagination
                  component="div"
                  count={paginatorInfo.total}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  page={paginatorInfo.currentPage - 1}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={[25, 50, 100]}
                />
              </CardActions>
            )}
          </Card>
          <TableEditBar selected={[]}/>
      </div>
    );
};

export default Results;
